import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
import config from 'react-global-configuration';
import renderHTML from 'react-render-html';

import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import { BlackHeading, Black, LogeButtonSlim, BorderLine } from '../GeneralStyle'
import { ProfileBox } from './ProfileStyle'


class HotelCard extends Component {
  render() {

    const { hotel } = this.props

    return (
      // <ProfileBox style={{ padding: 0 }} >

        <div id={"hotel_"+hotel.id}>

        <Row>
          <BorderLine width={"98%"} />
        </Row>
        <Row className={'row-eq-height-resp'}>
          <Col sm={12} md={3}>
            <div style={{height: 150, textAlign: "center"}}>
              <img style={{maxHeigth:'100%', maxWidth:'100%', marginTop: 10, height: "100%", objectFit: "contain"}} role="presentation" src={`${config.get('CLOUDINARY_URL')}${!hotel.image ? "wappen_text_zrwh0q" : hotel.image}.jpg`}/>
            </div>
          </Col>
          <Col sm={12} md={9} className={'blog-content'}>
            <BlackHeading style={{textAlign: "left"}}>{ hotel.name }</BlackHeading>
            {/* { hotel.golfCourse &&
              <p>
                <span style={{color: "black"}}>bei </span>
                <a href="" style={{ marginTop: 10}}>
                  {hotel.golfCourse.courseName}
                </a>
              </p>
            } */}
            <Black style={{display: "block", margin: "20px 0 15px 0"}}>
              { renderHTML(hotel.text) }
            </Black>
            {/* <a href="" style={{display: "block", marginTop: 10}}>
              🌍 Webseite anzeigen
            </a> */}
            <LogeButtonSlim
              hoverFontColor={"white"}
              style={{marginLeft: 0}}
              onClick={() => { window.open(hotel.link, "_blank") }}>
              Jetzt buchen
            </LogeButtonSlim>
          </Col>
        </Row>
        </div>

      // </ProfileBox>
    )
  }
}
export default HotelCard;



// WEBPACK FOOTER //
// /src/components/internal/HotelCard.js